module.exports = __webpack_public_path__ + "static/media/S5_Emailing.ad617dbc.svg";